/**
 * 魔方状态模型（54 字符 facelet，URFDLB 顺序）—— 自 cube.js 平移，逻辑未改
 *
 * 字符串结构（每个面 9 贴纸，行优先，从左上角开始）：
 *   索引 0-8   U 面（上，黄）
 *   索引 9-17  R 面（右，红）
 *   索引 18-26 F 面（前，绿）
 *   索引 27-35 D 面（下，白）
 *   索引 36-44 L 面（左，橙）
 *   索引 45-53 B 面（后，蓝）
 *
 * 字符含义：不是颜色名，而是"该贴纸所属的中心面的字母"（Kociemba 约定）。
 */

export type Face = 'U' | 'R' | 'F' | 'D' | 'L' | 'B';

export const FACES: Face[] = ['U', 'R', 'F', 'D', 'L', 'B'];

/** 每个面在 54 字符串中的起始索引 */
export const FACE_OFFSET: Record<Face, number> = { U: 0, R: 9, F: 18, D: 27, L: 36, B: 45 };

/** 标准已解状态字符串 */
export const SOLVED = 'UUUUUUUUURRRRRRRRRFFFFFFFFFDDDDDDDDDLLLLLLLLLBBBBBBBBB';

/** 面字母 → 展示色（设计规范六色） */
export const FACE_COLOR_CSS: Record<Face, string> = {
  U: '#ffcc00',
  R: '#ff3b30',
  F: '#34c759',
  D: '#f5f5f7',
  L: '#ff9500',
  B: '#007aff',
};

/** 面字母 → Three.js 颜色（hex 数字）—— D 面白色在下，U 面黄色在上 */
export const FACE_COLOR_HEX: Record<Face, number> = {
  U: 0xffcc00,
  R: 0xff3b30,
  F: 0x34c759,
  D: 0xf5f5f7,
  L: 0xff9500,
  B: 0x007aff,
};

/** 面字母 → 中文方位 */
export const FACE_CN: Record<Face, string> = { U: '上', D: '下', F: '前', B: '后', L: '左', R: '右' };
